
<form class="mce-form-section">

    <div class="mce-form-field-group">

        @if(cases().length > 1) {

        <div>
            <mat-form-field>
                <mat-label>single-core arrangement</mat-label>
                <mat-select [formField]="form().installation.singleCoreArrangement.case">
                    @for (option of cases(); track option.value) {
                    <mat-option [value]="option.value">{{option.label}}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>

        }


        @if(form().installation.singleCoreArrangement.case().value() !== sca.AC3phTrefoil) {
        <div>
            <app-spacing [form]="form().installation.singleCoreArrangement.spacing" label="single-core spacing"></app-spacing>
        </div>
        }

    </div>


</form>
